var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.82 28.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Text Box") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .tb-cls1 {\n        fill: inherit;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Whiteboard"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "tb-cls1",
    d: "m21.83,7.52v2.72h-6.03v12.1h-2.74v-12.1h-6.05v-2.72h14.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "tb-cls1",
    d: "m28.13,28.82h-4.12c-.38,0-.69-.31-.69-.69s.31-.69.69-.69h3.43v-3.43c0-.38.31-.69.69-.69s.69.31.69.69v4.12c0,.38-.31.69-.69.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tb-cls1",
    d: "m17.61,28.82h-6.4c-.38,0-.69-.31-.69-.69s.31-.69.69-.69h6.4c.38,0,.69.31.69.69s-.31.69-.69.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tb-cls1",
    d: "m4.8,28.82H.69c-.38,0-.69-.31-.69-.69v-4.12c0-.38.31-.69.69-.69s.69.31.69.69v3.43h3.43c.38,0,.69.31.69.69s-.31.69-.69.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tb-cls1",
    d: "m.69,18.3c-.38,0-.69-.31-.69-.69v-6.4c0-.38.31-.69.69-.69s.69.31.69.69v6.4c0,.38-.31.69-.69.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tb-cls1",
    d: "m.69,5.49c-.38,0-.69-.31-.69-.69V.69c0-.38.31-.69.69-.69h4.12c.38,0,.69.31.69.69s-.31.69-.69.69H1.37v3.43c0,.38-.31.69-.69.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tb-cls1",
    d: "m17.61,1.37h-6.4c-.38,0-.69-.31-.69-.69s.31-.69.69-.69h6.4c.38,0,.69.31.69.69s-.31.69-.69.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tb-cls1",
    d: "m28.13,5.49c-.38,0-.69-.31-.69-.69V1.37h-3.43c-.38,0-.69-.31-.69-.69s.31-.69.69-.69h4.12c.38,0,.69.31.69.69v4.12c0,.38-.31.69-.69.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tb-cls1",
    d: "m28.13,18.3c-.38,0-.69-.31-.69-.69v-6.4c0-.38.31-.69.69-.69s.69.31.69.69v6.4c0,.38-.31.69-.69.69Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextbox);
export default __webpack_public_path__ + "static/media/textbox.4bd3e3adf6ed6093e4a3d79195e4748f.svg";
export { ForwardRef as ReactComponent };